'use stricrt';

class NowLoading {
    constructor() {
    }

    dispLoading(msg) {
        if (msg == undefined) {
            msg = "";
        }
        let dispMsg = "<div class='loadingMsg'>" + msg + "</div>";
        if ($("#loading").length == 0) {
            $("body").append("<div id='loading'>" + dispMsg + "</div>");
        }
    }

    removeLoading() {
        $("#loading").remove();
    }
}
export default NowLoading;